import { i18n } from "services/i18nService";

export const FOUND_US_VIA_OPTIONS = [
  { id: "QuickBooks", name: "QuickBooks" },
  { id: "Accountant", name: "Accountant / Bookkeeper" },
  { id: "Search", name: "Internet Search" },
  { id: "Show", name: "Trade Show" },
  { id: "Friend", name: "Friend / Co-Worker" },
  { id: "Other", name: "Other" },
];

export const EMPTY_RECORD = {
  name: null,
  companyName: null,
  email: null, // will be overwritten in TrialSignup.js if logged in
  password: null,
  phone: null,
  promoCode: null,
  foundUsVia: null,
};

export const PLAN_CONFIG = {
  Companion: {
    bullets: [
      i18n("trial.companion.1"),
      i18n("trial.companion.2"),
      i18n("trial.companion.3"),
    ],
    subTitle: i18n("trial.subTitle.companion"),
  },
  Plus: {
    bullets: [i18n("trial.plus.1"), i18n("trial.plus.2"), i18n("trial.plus.3")],
    subTitle: i18n("trial.subTitle.plus"),
  },
  Pro: {
    bullets: [i18n("trial.pro.1"), i18n("trial.pro.2"), i18n("trial.pro.3")],
    subTitle: i18n("trial.subTitle.pro"),
  },
};
